import React, { useMemo } from "react"

import { FilterChip } from "@/components/common/Filters"
import type { PriceChangeFilterInput } from "@/graphql/codegen/graphql"
import { useGetSuppliers } from "@/hooks/useGetSuppliers"

interface SupplierFilterChipsProps {
  selectedSupplier?: string
  onRemove: (key: keyof PriceChangeFilterInput, value?: string) => void
}

const SupplierFilterChips: React.FC<SupplierFilterChipsProps> = ({ selectedSupplier, onRemove }) => {
  const { suppliers } = useGetSuppliers({ companyIds: selectedSupplier ? [selectedSupplier] : undefined })

  const supplierName = useMemo(
    () => suppliers.find((supplier) => supplier.companyId === selectedSupplier)?.name ?? "",
    [selectedSupplier, suppliers]
  )

  return (
    <FilterChip
      key='price-change-supplier-filter-chip'
      data-testid='price-change-supplier-filter-chip'
      label={`Supplier: ${supplierName}`}
      onDelete={() => onRemove("supplierId", undefined)}
    />
  )
}

export default SupplierFilterChips
